import { LoginStorage } from './../../../../../login/login.storage';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PropostaSimulacao } from '../../../models/proposta-simulacao';

@Component({
  selector: 'app-produtos',
  templateUrl: './produtos.component.html',
  styleUrls: ['./produtos.component.scss'],
})
export class ProdutosComponent implements OnInit {
  alive = true;
  seguros = [];
  assistencias = [];
  onSave = new EventEmitter();
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private loginStorage: LoginStorage
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      seguroSelecionado: [''],
      assistenciaSelecionado: [''],
    });
  }

  init(propostaSimulacao: PropostaSimulacao) {
    this.seguros = propostaSimulacao.simulacao.paymentProtectionInsurances;
    this.assistencias = propostaSimulacao.simulacao.assistances;

    const seguroSelecionado = propostaSimulacao.proposta.seguro;
    let assistenciaSelecionado = propostaSimulacao.proposta.assistencia;

    if (this.isLojistaLogado) {
      assistenciaSelecionado = -1;
    }

    this.form.patchValue({ seguroSelecionado, assistenciaSelecionado });
  }

  onClickSalvar(): void {
    const produtosSelecionados = this.form.value;
    this.onSave.emit({
      seguro: produtosSelecionados.seguroSelecionado,
      assistencia: produtosSelecionados.assistenciaSelecionado,
    });

    this.close();
  }

  close() {
    this.alive = false;
    this.bsModalRef.hide();
  }

  get isLojistaLogado() {
    return this.loginStorage.usuario.isLojista;
  }
}
